import { render, staticRenderFns } from "./responsive-image.vue?vue&type=template&id=1495784d&scoped=true&"
import script from "./responsive-image.vue?vue&type=script&lang=js&"
export * from "./responsive-image.vue?vue&type=script&lang=js&"
import style0 from "./responsive-image.vue?vue&type=style&index=0&id=1495784d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1495784d",
  null
  
)

export default component.exports